/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two values when neither is a clear starting point. Percentage difference measures their gap relative to their average.`)
};

const es_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compara dos valores cuando ninguno es un punto de partida claro. La diferencia porcentual mide su distancia relativa a su promedio.`)
};

const de_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleiche zwei Werte, wenn keiner ein eindeutiger Ausgangspunkt ist. Der prozentuale Unterschied misst ihre Differenz relativ zu ihrem Durchschnitt.`)
};

const nl_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk twee waarden wanneer geen van beide een duidelijk startpunt is. Percentageverschil meet hun afstand ten opzichte van hun gemiddelde.`)
};

const fr_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparez deux valeurs lorsqu'aucune n'est un point de départ évident. La différence en pourcentage mesure leur écart par rapport à leur moyenne.`)
};

const it_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta due valori quando nessuno dei due è un chiaro punto di partenza. La differenza percentuale misura il loro divario rispetto alla media.`)
};

const pt_br2_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois valores quando nenhum deles é um ponto de partida claro. A diferença percentual mede o intervalo entre eles em relação à sua média.`)
};

const pt_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois valores quando nenhum deles é claramente o ponto de partida. A diferença percentual mede o afastamento entre eles em relação à sua média.`)
};

const ja_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらも明確な開始点ではない2つの値を比較。パーセントの差は、両者の平均に対する差を測定します。`)
};

const zh_pct_difference_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在两个数值都没有明确起点时进行比较。百分比差异衡量它们相对于平均值的差距。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_intro", locale)
	if (locale === "en") return en_pct_difference_intro(inputs)
	if (locale === "es") return es_pct_difference_intro(inputs)
	if (locale === "de") return de_pct_difference_intro(inputs)
	if (locale === "nl") return nl_pct_difference_intro(inputs)
	if (locale === "fr") return fr_pct_difference_intro(inputs)
	if (locale === "it") return it_pct_difference_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_intro(inputs)
	if (locale === "pt") return pt_pct_difference_intro(inputs)
	if (locale === "ja") return ja_pct_difference_intro(inputs)
	return zh_pct_difference_intro(inputs)
};